import { SvgIcon } from "@mui/material";

const CircleCheckIcon = ({ circleColor = "#41D179", checkColor = "#262A2E", ...props }) => (
  <SvgIcon viewBox='0 0 16 16' {...props}>
    <circle cx='8' cy='8' r='8' fill={circleColor} />
    <path
      d='M11.3337 5.5L6.75033 10.0833L4.66699 8'
      fill='none'
      stroke={checkColor}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SvgIcon>
);

export default CircleCheckIcon;
